/**
 * Catalog Vuex module for Portal Application
 * Controls the data and actions for the Catalogs
 * 
 * @module Catalogs
 * @see
 * @author Bailey Kulman (Fresche Solutions)
 * @date June 2023
 */

import portalapi from "@services/portalapi";
import { resetStateData } from "@/utils/vuexStoreUtils";
import { getField, updateField } from "vuex-map-fields";

const DEFAULT_STATE = {
    regularCatalogItems: [],
    itemChanges: [],
    itemChangeTypes: [],
    newItems: [],
};

const state = structuredClone(DEFAULT_STATE);

const getters = {
    getField, // for vuex-map-fields

    getRegularCatalogItems(st) {
        return st.regularCatalogItems;
    },

    getItemChanges(st) {
        return st.itemChanges;
    },

    getItemChangeTypes(st) {
        return st.itemChangeTypes;
    },

    getNewItems(st) {
        return st.newItems;
    },
};

const mutations = {
    updateField, // for vuex-map-fields

    async clearStateData(st) {
        st = resetStateData(st, DEFAULT_STATE);
    },

    setRegularCatalogItems(st, payload) {
        st.regularCatalogItems = payload;
    },

    setItemChanges(st, payload) {
        st.itemChanges = payload;
    },

    setItemChangeTypes(st, payload) {
        st.itemChangeTypes = payload;
    },

    setNewItems(st, payload) {
        st.newItems = payload;
    },
};

const actions = {

    // Get Regular Catalog items
    async fetchRegularCatalogItems({ commit }, payload) 
    {
        const requestPayload = {
            page: (payload && payload.page ? payload.page : 1),
            itemsPerPage: (payload && payload.itemsPerPage ? payload.itemsPerPage : 20),
            filters: (payload && payload.filters ? payload.filters : []),
            sortBy: (payload && payload.sortBy ? payload.sortBy : {column: "itemNumber", state: 0}),
        };

        const response = await portalapi.moduleCatalogs.getRegularCatalogData(requestPayload);

        if (response.status === vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
            commit("setRegularCatalogItems", response.data);
        }
    },


    // Get Item Changes
    async fetchItemChanges({ commit }, payload) 
    {
        const requestPayload = {
            page: (payload && payload.page ? payload.page : 1),
            itemsPerPage: (payload && payload.itemsPerPage ? payload.itemsPerPage : 20),
            filters: (payload && payload.filters ? payload.filters : []),
            sortBy: (payload && payload.sortBy ? payload.sortBy : {column: "eventDate", state: "desc"}),
        };

        const response = await portalapi.moduleCatalogs.getItemChanges(requestPayload);

        if (response && response.status === vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
            commit("setItemChanges", response.data);
        }
    },


    // Get Item Change Types
    async fetchItemChangeTypes(context)
    {
        var commit = context.commit;
        if (context.state.itemChangeTypes.length == 0) {
            const response = await portalapi.moduleCatalogs.getItemChangeTypes();

            if (response && response.status === vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
                commit("setItemChangeTypes", response.data);
            }
        }
    },


    // Get New Items Catalog items
    async fetchNewItems({ commit }, payload) 
    {
        const requestPayload = {
            page: (payload && payload.page ? payload.page : 1),
            itemsPerPage: (payload && payload.itemsPerPage ? payload.itemsPerPage : 20),
            filters: (payload && payload.filters ? payload.filters : []),
            sortBy: (payload && payload.sortBy ? payload.sortBy : {column: "eventDate", state: "desc"}),
        };

        const response = await portalapi.moduleCatalogs.getNewItems(requestPayload);

        if (response && response.status === vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
            commit("setNewItems", response.data);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
